(function () {
  'use strict';

  const root = document.querySelector('.cnv-faq-page');
  if (!root) return;

  const searchInput = root.querySelector('.cnv-faq-search__input');
  const clearBtn = root.querySelector('.cnv-faq-search__clear');
  const tabs = Array.from(root.querySelectorAll('.cnv-faq-tab'));
  const cats = Array.from(root.querySelectorAll('.cnv-faq__cat'));
  const items = Array.from(root.querySelectorAll('.cnv-faq__item'));
  const emptyState = root.querySelector('.cnv-faq__empty');

  // Populate counts
  const totalEl = root.querySelector('[data-total]');
  if (totalEl) totalEl.textContent = items.length;
  cats.forEach((cat) => {
    const slug = cat.dataset.cat;
    const count = cat.querySelectorAll('.cnv-faq__item').length;
    const countEl = root.querySelector(`[data-count="${slug}"]`);
    if (countEl) countEl.textContent = count;
  });

  let activeFilter = 'all';
  let activeQuery = '';

  function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlight(text, query) {
    if (!query) return text;
    const pattern = new RegExp('(' + escapeRegex(query) + ')', 'ig');
    return text.replace(pattern, '<mark>$1</mark>');
  }

  function applyFilters() {
    const q = activeQuery.trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const cat = item.closest('.cnv-faq__cat').dataset.cat;
      const searchText = item.dataset.search || '';
      const catMatch = activeFilter === 'all' || cat === activeFilter;
      const queryMatch = !q || searchText.indexOf(q) !== -1;
      const show = catMatch && queryMatch;

      item.classList.toggle('is-hidden', !show);
      if (show) visibleCount += 1;

      // Auto-open first match when searching, close otherwise
      if (q) {
        item.open = show;
      }

      // Highlight matching text in question
      const qTextEl = item.querySelector('.cnv-faq__q-text');
      if (qTextEl) {
        const original = qTextEl.dataset.original || qTextEl.textContent;
        qTextEl.dataset.original = original;
        qTextEl.innerHTML = q ? highlight(original, q) : original;
      }
    });

    // Hide empty categories
    cats.forEach((cat) => {
      const visibleItems = cat.querySelectorAll('.cnv-faq__item:not(.is-hidden)');
      const catMatch = activeFilter === 'all' || cat.dataset.cat === activeFilter;
      cat.classList.toggle('is-hidden', !catMatch || visibleItems.length === 0);
    });

    // Empty state
    if (emptyState) {
      emptyState.hidden = visibleCount !== 0;
    }

    // Clear button visibility
    if (clearBtn) {
      clearBtn.hidden = !q;
    }
  }

  // Search input
  if (searchInput) {
    let debounceTimer;
    searchInput.addEventListener('input', function (e) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        activeQuery = e.target.value || '';
        applyFilters();
      }, 120);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.target.value = '';
        activeQuery = '';
        applyFilters();
        e.target.blur();
      }
    });
  }

  // Clear button
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (searchInput) {
        searchInput.value = '';
        searchInput.focus();
      }
      activeQuery = '';
      applyFilters();
    });
  }

  // Tab switching
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      activeFilter = tab.dataset.filter || 'all';
      applyFilters();
      // Scroll first visible category into view on mobile
      if (window.innerWidth < 750) {
        const firstVisibleCat = cats.find(function (c) { return !c.classList.contains('is-hidden'); });
        if (firstVisibleCat) {
          const top = firstVisibleCat.getBoundingClientRect().top + window.pageYOffset - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    });
  });

  // Initial pass
  applyFilters();

  // Close other items when opening one (optional: accordion mode).
  // We keep multi-open by default so users can compare answers side by side.
})();
